export default {
  heading: 'Burford-Rustic, san-serif',
  body: 'Source Sans Pro, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Oleo Script Swash Caps, san-serif',
  googleFonts: ['Source Sans Pro:100,200,300,400,500,600,700,800,900', 'Oleo Script Swash Caps'],
  customFamilies: ['Burford-Rustic'],
  customUrls: ['https://www.gonation.biz/fonts/burford-rustic/burford-rustic.css']
}
